var _g, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 144,
    viewBox: "0 0 143 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3445_26637)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 69.5,
    r: 61.5,
    fill: "#2C292A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 69.5,
    r: 57.9451,
    stroke: "#2C292A",
    strokeWidth: 7.10983
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.4997,
    cy: 69.4997,
    r: 55.8121,
    fill: "#2C292A",
    stroke: "#FBB723",
    strokeWidth: 1.42197
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7735,
    cy: 69.8552,
    r: 1.42197,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.514,
    cy: 69.8552,
    r: 1.42197,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4713 55.711L24.6987 54.6771L29.2023 55.6122C29.6815 55.7117 30.0814 55.9121 30.402 56.2135C30.7203 56.5144 30.9406 56.8903 31.0629 57.3411C31.1829 57.7915 31.1827 58.2901 31.0624 58.8371C30.9425 59.3818 30.7331 59.8358 30.434 60.1991C30.1328 60.562 29.7736 60.8176 29.3564 60.9658C28.937 61.1135 28.4877 61.1376 28.0084 61.0381L23.5049 60.103L23.7317 59.0725L28.1516 59.9903C28.4614 60.0546 28.7516 60.0439 29.0222 59.9583C29.2932 59.8704 29.5255 59.7152 29.7189 59.4927C29.9102 59.2697 30.0437 58.9859 30.1195 58.6413C30.1958 58.2945 30.1937 57.9813 30.113 57.7019C30.0305 57.4197 29.8836 57.1869 29.6723 57.0036C29.4614 56.818 29.201 56.693 28.8912 56.6287L24.4713 55.711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6818 41.5149L36.7677 44.96L36.2688 45.7916L29.9769 46.3133L29.9435 46.369L34.4069 48.8955L33.8641 49.8004L27.7783 46.3553L28.2806 45.5179L34.5802 44.9965L34.6136 44.9409L30.1443 42.411L30.6818 41.5149Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2905 33.6274L42.3169 38.4897L41.5616 39.2265L36.5352 34.3642L37.2905 33.6274Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6553 29.432L43.1687 28.665L47.8125 25.8851L48.299 26.6521L46.4269 27.7729L49.6864 32.9112L48.784 33.4514L45.5245 28.3131L43.6553 29.432Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5747 29.1882L55.6868 22.4546L59.9254 21.3331L60.1706 22.2077L56.9521 23.0593L57.5273 25.1109L60.5247 24.3179L60.769 25.1892L57.7716 25.9822L58.3495 28.0437L61.6077 27.1817L61.8529 28.0563L57.5747 29.1882Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2838 27.0392L69.0209 26.9718L69.2417 19.982L71.5763 20.0516C72.2612 20.072 72.845 20.2295 73.3277 20.524C73.8104 20.8163 74.1743 21.2268 74.4196 21.7556C74.6671 22.2823 74.7794 22.9085 74.7565 23.6344C74.7335 24.3625 74.5806 24.9842 74.2979 25.4996C74.0174 26.015 73.6224 26.4064 73.1129 26.6736C72.6034 26.9385 71.9937 27.0604 71.2838 27.0392ZM70.1046 26.0817L71.2549 26.116C71.7873 26.1319 72.2331 26.045 72.5921 25.8553C72.9512 25.6633 73.2244 25.3788 73.4117 25.0017C73.599 24.6224 73.7014 24.1563 73.7189 23.6034C73.7362 23.0551 73.6633 22.5871 73.5002 22.1997C73.3393 21.8123 73.0902 21.5145 72.7529 21.3063C72.4156 21.0981 71.992 20.9864 71.4823 20.9712L70.2673 20.9349L70.1046 26.0817Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5478 30.6507L92.0458 24.5951L95.8955 26.6936L95.4411 27.4802L92.5179 25.8867L91.4521 27.7317L94.1745 29.2157L93.7218 29.9993L90.9995 28.5153L89.9286 30.3692L92.8878 31.9823L92.4334 32.7688L88.5478 30.6507Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3391 36.8619L103.365 31.9996L104.121 32.7364L99.7472 36.9672L102.016 39.1799L101.363 39.8114L98.3391 36.8619Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 46.77L105.562 44.7933L111.749 41.5337L112.888 43.573C113.222 44.1713 113.385 44.7504 113.377 45.3103C113.371 45.869 113.201 46.3842 112.868 46.8558C112.537 47.3283 112.051 47.7338 111.408 48.0723C110.764 48.4118 110.145 48.5873 109.552 48.5988C108.96 48.6123 108.417 48.4662 107.923 48.1604C107.431 47.8537 107.012 47.3902 106.666 46.77ZM106.892 45.2848L107.453 46.2896C107.713 46.7547 108.017 47.0946 108.367 47.3094C108.718 47.523 109.105 47.6172 109.529 47.592C109.955 47.5658 110.413 47.4237 110.902 47.1659C111.387 46.9102 111.757 46.6166 112.01 46.2853C112.264 45.956 112.394 45.5951 112.402 45.2027C112.41 44.8102 112.289 44.3914 112.041 43.9461L111.448 42.8847L106.892 45.2848Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.666 54.39L117.557 54.2142L118.665 59.512L117.774 59.6878L117.327 57.5519L111.357 58.7296L111.142 57.7001L117.112 56.5225L116.666 54.39Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.833 82.9818L117.606 84.0156L113.102 83.0805C112.623 82.981 112.223 82.7806 111.903 82.4792C111.584 82.1783 111.364 81.8024 111.242 81.3516C111.122 80.9013 111.122 80.4026 111.242 79.8557C111.362 79.311 111.572 78.857 111.871 78.4936C112.172 78.1307 112.531 77.8752 112.948 77.727C113.368 77.5792 113.817 77.5551 114.296 77.6546L118.8 78.5897L118.573 79.6202L114.153 78.7025C113.843 78.6382 113.553 78.6488 113.283 78.7344C113.011 78.8223 112.779 78.9775 112.586 79.2C112.395 79.423 112.261 79.7068 112.185 80.0515C112.109 80.3983 112.111 80.7114 112.192 80.9909C112.274 81.273 112.421 81.5058 112.632 81.6892C112.843 81.8748 113.104 81.9997 113.413 82.0641L117.833 82.9818Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.623 97.1782L105.537 93.7332L106.036 92.9015L112.328 92.3798L112.361 92.3242L107.898 89.7976L108.441 88.8928L114.526 92.3378L114.024 93.1753L107.724 93.6966L107.691 93.7522L112.16 96.2821L111.623 97.1782Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.016 105.065L99.9898 100.203L100.745 99.4662L105.771 104.329L105.016 105.065Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6494 109.261L99.136 110.028L94.4922 112.808L94.0056 112.041L95.8778 110.92L92.6183 105.782L93.5207 105.242L96.7802 110.38L98.6494 109.261Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.73 109.505L86.6179 116.238L82.3793 117.36L82.1341 116.485L85.3526 115.634L84.7774 113.582L81.78 114.375L81.5357 113.504L84.5331 112.711L83.9551 110.649L80.697 111.511L80.4518 110.637L84.73 109.505Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0209 111.654L73.2838 111.721L73.063 118.711L70.7284 118.641C70.0435 118.621 69.4597 118.463 68.977 118.169C68.4943 117.876 68.1303 117.466 67.8851 116.937C67.6376 116.41 67.5253 115.784 67.5482 115.058C67.5712 114.33 67.7241 113.709 68.0068 113.193C68.2873 112.678 68.6823 112.286 69.1918 112.019C69.7013 111.754 70.311 111.632 71.0209 111.654ZM72.2 112.611L71.0498 112.577C70.5173 112.561 70.0716 112.648 69.7126 112.837C69.3535 113.029 69.0803 113.314 68.893 113.691C68.7057 114.07 68.6033 114.536 68.5858 115.089C68.5685 115.638 68.6414 116.106 68.8045 116.493C68.9654 116.88 69.2144 117.178 69.5518 117.386C69.8891 117.595 70.3126 117.706 70.8223 117.722L72.0374 117.758L72.2 112.611Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7569 108.042L50.2589 114.097L46.4092 111.999L46.8636 111.212L49.7868 112.806L50.8526 110.961L48.1302 109.477L48.5829 108.693L51.3052 110.177L52.3761 108.323L49.4169 106.71L49.8713 105.924L53.7569 108.042Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9656 101.831L38.9392 106.694L38.184 105.957L42.5575 101.726L40.2892 99.5134L40.942 98.8819L43.9656 101.831Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6388 91.9226L36.7423 93.8993L30.5552 97.1589L29.4167 95.1196C29.0827 94.5213 28.9197 93.9422 28.9277 93.3824C28.9337 92.8236 29.1036 92.3084 29.4372 91.8368C29.7676 91.3643 30.2541 90.9589 30.8966 90.6204C31.5411 90.2808 32.1599 90.1053 32.7529 90.0938C33.3449 90.0804 33.8878 90.2265 34.3817 90.5322C34.8735 90.839 35.2926 91.3024 35.6388 91.9226ZM35.4123 93.4078L34.8514 92.403C34.5917 91.9379 34.2873 91.598 33.938 91.3833C33.5868 91.1696 33.1993 91.0754 32.7755 91.1006C32.3496 91.1269 31.892 91.2689 31.4026 91.5268C30.9172 91.7825 30.5481 92.076 30.2952 92.4073C30.0411 92.7366 29.9103 93.0975 29.9026 93.49C29.895 93.8824 30.0154 94.3013 30.264 94.7465L30.8566 95.8079L35.4123 93.4078Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6385 84.3031L24.7474 84.4789L23.64 79.1811L24.5311 79.0054L24.9776 81.1412L30.9475 79.9635L31.1627 80.993L25.1928 82.1706L25.6385 84.3031Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3445_26637)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.4981,
    cy: 69.5001,
    r: 30.9277,
    fill: "#2C292A"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2773 80.5202L83.9421 69.8554L73.2773 59.1907",
    stroke: "url(#paint0_linear_3445_26637)",
    strokeWidth: 4.2659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3477 80.52L69.0124 69.8553L58.3477 59.1906",
    stroke: "url(#paint1_linear_3445_26637)",
    strokeWidth: 4.2659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3445_26637",
    x: 0.0462437,
    y: 0.890174,
    width: 142.908,
    height: 142.908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.84393
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.97688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3445_26637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3445_26637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3445_26637",
    x: 33.4605,
    y: 31.4626,
    width: 76.0751,
    height: 76.0751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55491
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0622222 0 0 0 0 0.0637036 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3445_26637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3445_26637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3445_26637",
    x1: 78.6097,
    y1: 59.1907,
    x2: 78.6097,
    y2: 80.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3445_26637",
    x1: 63.68,
    y1: 59.1906,
    x2: 63.68,
    y2: 80.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503803"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelo);
export default __webpack_public_path__ + "static/media/Selo.b1a3ae10593a848628cdd8e1c6134aef.svg";
export { ForwardRef as ReactComponent };